import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';

import constants from '../../constants/appConstants';
import TreeWrapper from './TreeWrapper';

import 'react-dropdown-tree-select/dist/styles.css';

export default class FilterCounty extends Component {
  state = {
    location: {},
  };

  constructor(props) {
    super(props);

    this.states = constants.STATE_COUNTIES;
    this.states = this.props.states;
  }

  componentWillReceiveProps = (nextProps) => {
    if (!isEqual(nextProps.value, this.props.value)) {
      this.setState({
        location: nextProps.value || {},
      });
    }
  };

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(nextProps.value, this.props.value);
  };

  onChange = (value, selectedNodes) => {
    const localValues = this.props.value;
    const split = value.label.split(': ');

    const county = split[1];
    const state = split[0];

    if (typeof localValues[state] === 'undefined') {
      localValues[state] = [];
    }

    if (value.checked === true) {
      /**
       * If the current selected value is All, clear out the array first so we don't get leftover data
       */
      if (value.label.indexOf('All') > -1) {
        localValues[state] = [];
      }

      const foundCounty = this.states.find((county) => county.label.indexOf(state) > -1);
      localValues[state].push(county);

      /**
       * If there's a full match set everything up correctly
       */
      if (localValues[state].length === foundCounty.children.length) {
        localValues[state] = ['All'];
      }
    } else {
      /**
       * Ensure going from all to all minus one selects all of the children except the deselected one
       */
      if (localValues[state][0] === 'All') {
        localValues[state].splice(0, 1);

        const foundState = this.states.find((county) => county.value === state);

        if (localValues[state].length === 0 && value.label.indexOf('All') === -1) {
          foundState.children.forEach((child) => {
            child.checked = true;

            localValues[state].push(child.value.split(', ')[0]);
          });
        }
      }

      const index = localValues[state].indexOf(county);

      localValues[state].splice(index, 1);

      if (localValues[state].length === 0) {
        delete localValues[state];
      }
    }

    this.props.handleChange(localValues);
  };

  generateSelectedValues(values) {
    const valueKeys = Object.keys(values || {});

    /**
     * Reset all counties
     */
    this.states.forEach((state) => {
      state.checked = false;
      state.value = state.id;
      state.key = state.id;
      state.label = state.name + ': All';
      state.children = state.counties.map((county) => {
        county.value = county.id;
        county.key = county.id;
        county.label = state.name + ': ' + county.name;
        county.checked = false;
        return county;
      });
    });
    if (valueKeys.length > 0) {
      valueKeys.forEach((valueKey) => {
        const found = this.states.find((state) => state.name === valueKey);

        if (typeof found !== 'undefined') {
          if (values[valueKey][0] === 'All' || values[valueKey] === 'All') {
            found.checked = true;

            found.children.forEach((child) => (child.checked = true));
          } else if (values[valueKey].length > 0) {
            values[valueKey].forEach((value) => {
              const child = found.children.find((childSearch) => {
                return childSearch.name.indexOf(value) > -1;
              });

              if (typeof child !== 'undefined') {
                child.checked = true;
              }
            });
          }
        }
      });
    }
  }

  render() {
    this.generateSelectedValues(this.props.value);

    return (
      <div className='flexer'>
        <strong>Location: </strong>
        <TreeWrapper
          data={this.states}
          onChange={this.onChange.bind(this)}
          placeholderText='Search for Locations (Defaults to All)'
          showPartiallySelected={true}
          clearSearchOnChange={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/FilterCounty.js